"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="splitcontentwithimage" className="bg-background text-white py-24 overflow-hidden !h-[650px] lg:py-[120px]">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="lg:col-span-6 flex flex-col gap-8">
            <div className="space-y-6">
              <h2 className="font-default tracking-tight leading-tight !font-bold !text-[hsl(0,0%,100%)] !text-4xl ![margin:-100px_0px_24px_20px]">More Indomitable <br />Energy &amp; Support</h2>

              <div className="space-y-4">
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">"They helped me find my most truthful purpose that gives me more indomitable energy and support.&nbsp;</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">Their ongoing support enabled me to keep a calm perspective in the heat of the day-to-day dynamics of running my business. <br /><br />Working with Paolo and Raamon moved me from overwhelm to calmness, from confusion to clarity resulting in improved financial results.</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">They have absolute integrity and authenticity in the work they do.&nbsp;</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">As a business leader if you want to take your and your company’s leadership performance to the next level I strongly recommend talking with them.”</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg"><b data-ast-id="f:/src/pages/Clients/sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy.tsx|sig:pnjg93" data-ast-start="2190" data-ast-end="2406">Micheal Major<br />Founder Major &amp; Associates</b><br /></p>
                
                
                <p className="text-base md:text-lg text-white leading-relaxed"><div data-ast-id="f:/src/pages/Clients/sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopy.tsx|sig:53byq1" data-ast-start="2634" data-ast-end="2645"></div><div></div></p>
                
                
                
                
                
                
                
              </div>
            </div>

            <div>
              <Button asChild size="lg" className="text-primary-foreground inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-10 has-[>svg]:px-4 rounded-full px-8 bg-accent transition-all duration-300 !text-[hsl(0,0%,100%)] !text-base disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover">
                
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-6">
            <div className="bg-muted-dark-background rounded-2xl overflow-hidden shadow-strong border border-border/30 mx-auto -mt-[70px] max-w-[315px]">
              <img src="https://newmavericks.com/wp-content/uploads/2026/04/Michael-Major.png" alt="NewMavericks Strategic Visual" className="block w-full object-cover transition-transform duration-700 ease-in-out hover:scale-105" />
              
            </div>
            <div className="mt-[25px] flex justify-center">
              <Button asChild size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-base font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-5 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-12 has-[>svg]:px-5 rounded-full px-10 bg-accent transition-all duration-300 !text-[hsl(0,0%,100%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}